import { connect } from "react-redux";
import Archive from "../../components/Segment/List/Archive/Archive";
import {
  fetchSegmentSummary,
  clearSegmentSummary,
} from "../../actions/SegmentDetail";
import { reactiveSegment } from "../../actions/SegmentList";

import {
  getSegmentList,
  getAttributes,
  copySegment,
  searchByName,
} from "../../actions/SegmentList";
import { selectClient } from "../../actions/App";

const mapStateToProps = state => {
  const { segment_summary } = state.segmentDetail;
  const {
    segment_list_archive,
    segment_attributes,
    copy_segment,
    searchByNameResult,
    reactive_success,
    reactive_on_progress,
  } = state.segmentList;
  const { roleName, client_info, roleId } = state.app;
  return {
    segment_summary,
    segment_list_archive,
    selected_client: state.app.selected_client,
    segment_attributes,
    copy_segment,
    roleName,
    client_info,
    roleId,
    segment_edit_creation: state.segmentCreation,
    searchByNameResult,
    reactive_success,
    reactive_on_progress,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reactiveSegment: id => {
      dispatch(reactiveSegment(id));
    },
    getSegmentList: data => {
      dispatch(getSegmentList(data));
    },
    fetchSegmentDetail: id => {
      dispatch(fetchSegmentSummary(id));
      dispatch(getAttributes(id));
    },
    clearSegmentSummary: () => {
      dispatch(clearSegmentSummary());
    },
    getAttributes: id => {
      dispatch(getAttributes(id));
    },
    copySegment: id => {
      dispatch(copySegment(id));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
    searchByName: obj => {
      dispatch(searchByName(obj));
    },
  };
};

const SegmentActive = connect(mapStateToProps, mapDispatchToProps)(Archive);

export default SegmentActive;



// WEBPACK FOOTER //
// ./src/containers/SegmentList/Archive.js